import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-cycle
import NavLink from './NavItem/NavLink';
// eslint-disable-next-line import/no-cycle
import NavExpand from './NavItem/NavExpand';
// eslint-disable-next-line import/no-cycle
import NavAction from './NavItem/NavAction';

const action = 'action';
const link = 'link';

export default function NavItem({ navItem, depth, onNavItem }) {
  const {
    primaryText, url, icon, children, type,
  } = navItem;

  if (children && children.data.length) {
    return <NavExpand navItem={navItem} depth={depth} onNavItem={onNavItem} />;
  }

  if (type === 'action') {
    return <NavAction url={url} primaryText={primaryText} onNavItem={onNavItem} />;
  }

  return (
    <NavLink url={url} primaryText={primaryText} icon={icon} depth={depth} onNavItem={onNavItem} />
  );
}

const navItemProps = {
  navItem: PropTypes.shape({
    primaryText: PropTypes.string,
    url: PropTypes.string,
    icon: PropTypes.string,
    children: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    type: PropTypes.string,
  }).isRequired,
  depth: PropTypes.number.isRequired,
  onNavItem: PropTypes.func.isRequired,
  type: PropTypes.string,
};

export { navItemProps, action, link };

NavItem.propTypes = navItemProps;
NavItem.defaultProps = {
  type: link,
};
